import axios from 'axios'

export const executeGet = function (path, onSuccess, onError) {
  axios.get(path)
    .then(function (response) {
      onSuccess(response.data)
    })
    .catch(function (error) {
      onError(error.response.data)
    })
}

export const executePost = function (path, payload, onSuccess, onError) {
  axios.post(path, payload)
    .then(function (response) {
      onSuccess(response.data)
    })
    .catch(function (error) {
      if (error?.response?.status === 599) {
        alert('For technical reasons, registration with mobile phone number doesn\'t work. Please use your email address to register.')
      }
      onError(error.response.data)
    })
}

export const executePut = function (path, payload, onSuccess, onError) {
  axios.put(path, payload)
    .then(function (response) {
      onSuccess(response.data)
    })
    .catch(function (error) {
      onError(error.response.data)
    })
}

export const executePatch = function (path, payload, onSuccess, onError) {
  axios.patch(path, payload)
    .then(function (response) {
      onSuccess(response.data)
    })
    .catch(function (error) {
      onError(error.response.data)
    })
}
